<template>
  <v-sheet
    shaped
    rounded
    class="mx-3 d-flex flex-column align-center px-3 my-3"
  >
    <h3 class="  text-center">{{ Total.Cash }}</h3>
    <v-chip-group>
      <v-chip
        pill
        small
        color="teal "
        text-color="white"
        active-class="green"
        light
        >{{ Total.Dr.toLocaleString() }}
        <v-avatar
          size="avatarSize"
          color="teal darken-2"
          class="white--text pa-4 my-4"
          right
        >
          In
        </v-avatar>
      </v-chip>
      <v-chip
        pill
        small
        color="error darken-1"
        text-color="white"
        active-class="green"
        light
        >{{ Total.Cr.toLocaleString() }}
        <v-avatar
          size="avatarSize"
          color="error darken-2"
          class="white--text pa-4 my-4"
          right
        >
          OUT
        </v-avatar>
      </v-chip>
    </v-chip-group>
  </v-sheet>
</template>
<script>
export default {
  props: {
    Total: { type: Object, required: true },
  },
};
</script>
